<div class="loading-wrapper">
  @if (modalitySchedule() === modalityEnum.MSV) {
  <div>
    <agenda-customer-ui-shimmer-fragment type="circle" height="90" width="90" />
  </div>
  <div>
    <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="55" />
    <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="65" marginBottom="15" />

    <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="75" />
    <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="65" />
    <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="65" />
  </div>
  }

  @if (modalitySchedule() === modalityEnum.PDL) {
    <div>
      <agenda-customer-ui-shimmer-fragment type="circle" height="90" width="90" />
    </div>
    <div>
      <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="55" />
      <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="65" />
      <agenda-customer-ui-shimmer-fragment type="rectangle" height="20" width="100" />
    </div>
  }
</div>
